import { useContext } from "react";
import { Box, CircularProgress } from "@mui/material";
import Order from "../../components/Order/Order";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import { AdminOrderContext } from "../../context/Admin/Order";

const AdminOrderContainer = () => {
  const { t } = useTranslation();
  usePageTitle("pages.order.title");
  const { isOrderLoaded, orderDetail: preorderDetail } =
    useContext(AdminOrderContext);

  return (
    <Box>
      {isOrderLoaded ? (
        preorderDetail === null ? (
          <div className="page-title-box">
            <p className="page-title">{t("techpack.not_found")}</p>
          </div>
        ) : (
          <Order />
        )
      ) : (
        <div>
          <CircularProgress />
        </div>
      )}
    </Box>
  );
};

export default AdminOrderContainer;
